// extracted by mini-css-extract-plugin
var _1 = "aZeJ2GXhC7ABpdPqOG0p";
export { _1 as "headings" }
